import type {
  CurrencyEntity,
} from '@dinosave/scraping/types';

const CURRENCIES: CurrencyEntity[] = [
  {
    code: 'USD',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'United States Dollar',
    flag: '/images/flags/us.svg',
  },
  {
    code: 'EUR',
    symbols: [
      '€',
    ],
    labels: [],
    name: 'Euro',
    flag: '/images/flags/eu.svg',
  },
  {
    code: 'GBP',
    symbols: [
      '£',
    ],
    labels: [],
    name: 'British Pound Sterling',
    flag: '/images/flags/gb.svg',
  },
  {
    code: 'INR',
    symbols: [
      '₹',
    ],
    labels: [],
    name: 'Indian Rupee',
    flag: '/images/flags/in.svg',
  },
  {
    code: 'CNY',
    symbols: [
      '¥',
    ],
    labels: [],
    name: 'Chinese Yuan',
    flag: '/images/flags/cn.svg',
  },
  {
    code: 'ARS',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'Argentine Peso',
    flag: '/images/flags/ar.svg',
  },
  {
    code: 'AUD',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'Australian Dollar',
    flag: '/images/flags/au.svg',
  },
  {
    code: 'BRL',
    symbols: [
      'R$',
    ],
    labels: [],
    name: 'Brazilian Real',
    flag: '/images/flags/br.svg',
  },
  {
    code: 'BGN',
    symbols: [
      'лв',
    ],
    labels: [],
    name: 'Bulgarian Lev',
    flag: '/images/flags/bg.svg',
  },
  {
    code: 'CAD',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'Canadian Dollar',
    flag: '/images/flags/ca.svg',
  },
  {
    code: 'CZK',
    symbols: [
      'Kč',
    ],
    labels: [],
    name: 'Czech Koruna',
    flag: '/images/flags/cz.svg',
  },
  {
    code: 'HRK',
    symbols: [
      'kn',
    ],
    labels: [],
    name: 'Croatian Kuna',
    flag: '/images/flags/hr.svg',
  },
  {
    code: 'DKK',
    symbols: [
      'kr',
    ],
    labels: [],
    name: 'Danish Krone',
    flag: '/images/flags/dk.svg',
  },
  {
    code: 'GEL',
    symbols: [
      '₾',
    ],
    labels: [],
    name: 'Georgian Lari',
    flag: '/images/flags/ge.svg',
  },
  {
    code: 'HKD',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'Hong Kong Dollar',
    flag: '/images/flags/hk.svg',
  },
  {
    code: 'HUF',
    symbols: [
      'Ft',
    ],
    labels: [],
    name: 'Hungarian Forint',
    flag: '/images/flags/hu.svg',
  },
  {
    code: 'ISK',
    symbols: [
      'kr',
    ],
    labels: [],
    name: 'Icelandic Krona',
    flag: '/images/flags/is.svg',
  },
  {
    code: 'IDR',
    symbols: [
      'Rp',
    ],
    labels: [],
    name: 'Indonesian Rupiah',
    flag: '/images/flags/id.svg',
  },
  {
    code: 'ILS',
    symbols: [
      '₪',
    ],
    labels: [],
    name: 'Israeli Shekel',
    flag: '/images/flags/il.svg',
  },
  {
    code: 'JPY',
    symbols: [
      '円',
    ],
    labels: [],
    name: 'Japanese Yen',
    flag: '/images/flags/jp.svg',
  },
  {
    code: 'KRW',
    symbols: [
      '₩',
    ],
    labels: [],
    name: 'South Korean Won',
    flag: '/images/flags/kr.svg',
  },
  {
    code: 'MYR',
    symbols: [
      'RM',
    ],
    labels: [],
    name: 'Malaysian Ringgit',
    flag: '/images/flags/my.svg',
  },
  {
    code: 'MXN',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'Mexican Peso',
    flag: '/images/flags/mx.svg',
  },
  {
    code: 'NZD',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'New Zealand Dollar',
    flag: '/images/flags/nz.svg',
  },
  {
    code: 'NOK',
    symbols: [
      'kr',
    ],
    labels: [],
    name: 'Norwegian Krone',
    flag: '/images/flags/no.svg',
  },
  {
    code: 'PLN',
    symbols: [
      'zł',
    ],
    labels: [],
    name: 'Polish Złoty',
    flag: '/images/flags/pl.svg',
  },
  {
    code: 'RON',
    symbols: [],
    labels: [],
    name: 'Romanian Leu',
    flag: '/images/flags/ro.svg',
  },
  {
    code: 'RUB',
    symbols: [
      '₽',
    ],
    labels: [],
    name: 'Russian Ruble',
    flag: '/images/flags/ru.svg',
  },
  {
    code: 'SAR',
    symbols: [
      'ر.س',
    ],
    labels: [],
    name: 'Saudi Riyal',
    flag: '/images/flags/sa.svg',
  },
  {
    code: 'SGD',
    symbols: [
      '$',
    ],
    labels: [],
    name: 'Singapore Dollar',
    flag: '/images/flags/sg.svg',
  },
  {
    code: 'ZAR',
    symbols: [
      'R',
    ],
    labels: [],
    name: 'South African Rand',
    flag: '/images/flags/za.svg',
  },
  {
    code: 'SEK',
    symbols: [
      'kr',
    ],
    labels: [],
    name: 'Swedish Krona',
    flag: '/images/flags/se.svg',
  },
  {
    code: 'CHF',
    symbols: [
      'Fr.',
    ],
    labels: [],
    name: 'Swiss Franc',
    flag: '/images/flags/ch.svg',
  },
  {
    code: 'THB',
    symbols: [
      '฿',
    ],
    labels: [],
    name: 'Thai Baht',
    flag: '/images/flags/th.svg',
  },
  {
    code: 'TRY',
    symbols: [
      '₺',
    ],
    labels: [],
    name: 'Turkish Lira',
    flag: '/images/flags/tr.svg',
  },
  {
    code: 'UAH',
    symbols: [
      '₴',
    ],
    labels: [],
    name: 'Ukrainian Hryvnia',
    flag: '/images/flags/ua.svg',
  },
  {
    code: 'AED',
    symbols: [
      'د.إ',
    ],
    labels: [],
    name: 'UAE Dirham',
    flag: '/images/flags/ae.svg',
  },
];

export { CURRENCIES };
